import React, { forwardRef } from "react";

const Hero = forwardRef((props, ref) => {
  return (
    <div
      id="home"
      ref={ref}
      className="w-full bg-indigo-800 px-4 pt-40 lg:pt-12"
    >
      <div className="container max-w-[1280px] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-[1fr_2fr] ">
        <div className="flex flex-col justify-center gap-8 text-center lg:text-left">
          <h1 className="text-6xl lg:text-4xl font-serif text-white">
            Find the <span className="font-bold text-orange-600">best way</span>
            to create a successful project
          </h1>
          <p className="text-amber-500 text-2xl lg:text-base">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
          </p>
          <button className="bg-amber-500 w-fit  text-2xl rounded-lg mx-auto font-bold lg:mx-0 activeButton ">
            <a
              href="#contactus"
              className="flex gap-4 items-center text-indigo-900 px-4 py-3 hover:gap-6 hover:transition duration-200 ease-in-out"
            >
              Contact Us
              <svg className="stroke-indigo-900  w-6 h-6" viewBox="0 0 24 25">
                <path
                  d="M14 5.22101L21 12.221M21 12.221L14 19.221M21 12.221L3 12.221"
                  stroke="current"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </button>
        </div>
        <div className="relative">
          <div>
            <img
              className="animate-bounce absolute w-12 h-12 top-[29.9663299663%] left-[38.0202474691%]"
              src="/assets/icon_data.webp"
              alt="data"
            />
            <img
              className="animate-bounce absolute w-12 h-12 top-[37.7104377104%] left-[73.5658042745%]"
              src="/assets/icon_share.webp"
              alt="share"
            />
            <img
              className="animate-bounce absolute w-12 h-12 top-[74.7474747475%] left-[13.8357705287%]"
              src="/assets/icon_shield.webp"
              alt="shield"
            />
          </div>
          <figure className="min-w-[320px] lg:w-full lg:max-w-full xl:w-[889px] xl:max-w-[889px] object-cover">
            <img src="/assets/HeroImage.webp" alt="" />
          </figure>
        </div>
      </div>
    </div>
  );
});

export default Hero;
